import { QuickOrderPositionDto } from "./quickOrderPositionDto";

export class QuickInvoiceDto {
	public customerId: number = 0;
	public comment: string = "";
	public positions: QuickOrderPositionDto[] = [];
}
